import { render } from "./FlowOperatorPanel.vue?vue&type=template&id=3bdf1afa"
import script from "./FlowOperatorPanel.vue?vue&type=script&lang=ts"
export * from "./FlowOperatorPanel.vue?vue&type=script&lang=ts"

import "./FlowOperatorPanel.vue?vue&type=style&index=0&id=3bdf1afa&lang=scss"
script.render = render

export default script